import axios from "axios";

// Basis-URL für die API
const axiosInstance = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`, // Deine API-IP-Adresse
  timeout: 5000, // Timeout für API-Anfragen (optional)
});

export default axiosInstance;
